module.exports = __webpack_public_path__ + "img/haft-poznan-12.2dd15838.jpg";